<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- タイトル -->
    <div class="title">
      <h1>問い合わせ詳細</h1>
    </div>

    <!-- 内閣府承認情報 -->
    <div class="approval-information">
      <!-- 内閣府承認情報内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 内閣府承認 -->
          <tr>
            <td class="item-name">運営事務局承認</td>
            <td class="item-information">
              <div [class.denial]="1 == inquiryInformation?.status.id">
                <div class="p-d-flex status">
                  <label class="p-as-center">
                    <!-- ステータス -->
                    <label class="status-name">
                      {{ inquiryInformation?.status.name }}</label
                    >
                    <!-- 承認日付 -->
                    <label>{{ inquiryInformation?.status_datetime }}</label>
                  </label>

                  <!-- 承認可否 -->
                  <button
                    pButton
                    type="button"
                    label="ステータス登録"
                    class="button3 approval-button"
                    (click)="openSmallApprovalDialog()"
                  ></button>
                </div>
                <!-- 承認時コメント -->
                <div class="status-comment">
                  {{ inquiryInformation?.status_comment }}
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 問い合わせ区分エリア -->
    <div class="inquiry-area">
      <!-- 問い合わせ区分 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 問い合わせ区分 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">問い合わせ区分</td>
            <td class="item-information">
              {{ getDicName(7, inquiryInformation?.inquiry_kbn) }}
            </td>
          </tr>
          <!-- 会員名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">会員名</td>
            <td class="item-information">
              {{ inquiryInformation.organization_name }}
            </td>
          </tr>
          <!-- 部局名/事業部名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">部局名/事業部名</td>
            <td class="item-information">
              {{ inquiryInformation.department_name }}
            </td>
          </tr>
          <!-- 課室名/部署名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">課室名/部署名</td>
            <td class="item-information">
              {{ inquiryInformation.division_name }}
            </td>
          </tr>
          <!-- 役職 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">役職</td>
            <td class="item-information">
              {{ inquiryInformation.jobposition_name }}
            </td>
          </tr>
          <!-- 氏名 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">氏名</td>
            <td class="item-information">
              {{ inquiryInformation.full_name }}
            </td>
          </tr>
          <!-- 電話番号 -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">電話番号</td>
            <td class="item-information">
              {{ inquiryInformation.tel }}
            </td>
          </tr>
          <!-- メールアドレス -->
          <tr class="inquiry-kbn-detail">
            <td class="item-name">eメールアドレス</td>
            <td class="item-information">
              {{ inquiryInformation.email }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 問い合わせ区分が"退会の申請"以外  -->
    <div *ngIf="3 != inquiryInformation?.inquiry_kbn">
      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>問い合わせ内容</h2>
      </div>
      <div class="confirmation-inquiry-textarea">
        {{ inquiryInformation?.inquiry }}
      </div>
    </div>

    <!-- 問い合わせ区分が"退会の申請"以外 -->
    <div *ngIf="3 == inquiryInformation?.inquiry_kbn">
      <!-- ご退会にあたり、下記ご留意ください -->
      <div class="withdrawal-note">
        <!-- サブタイトル -->
        <label class="warning">
          <h2>ご退会にあたり、下記ご留意ください</h2>
        </label>
        <div class="note">
          ●「団体退会」を選択された場合、団体プロフィール及びソリューション、並びに主催した分科会情報もプラットフォームより削除されます<br />
          ● 分科会主催者様の場合、分科会メンバー情報を処分してください<br />
          ●
          分科会にご参加されたことがある場合、分科会主催者へご退会の旨を直接ご連絡ください<br />
          ●
          退会の処理には、数日を要しますため、すぐに会員検索から削除されないことをご了承ください
        </div>
      </div>

      <!-- サブタイトル -->
      <div class="sub-title">
        <h2>退会時アンケート</h2>
      </div>
      <label>よろしければ、下記のアンケートにご回答ください</label>
      <!-- 退会時アンケート内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- （1）質問 -->
          <tr>
            <td class="item-updown-input-name">
              <div>（1）質問</div>
              <div class="input-name-note">
                ※複数選択可。<br />
                ※「その他」を選択の場合は、下の記入欄に内容を御記入ください。
              </div>
            </td>
          </tr>
          <tr>
            <td class="item-updown-information">
              <div *ngFor="let data of inquiryInformation?.questionary1">
                {{ data }}.{{ getDicName(1005, data) }}
              </div>
              {{ inquiryInformation?.questionary1_other }}
            </td>
          </tr>
          <!-- （2）質問 -->
          <tr>
            <td class="item-updown-input-name">
              <div>（2）質問</div>
              <div class="input-name-note">
                ※複数選択可。<br />
                ※「その他」を選択の場合は、下の記入欄に内容を御記入ください。
              </div>
            </td>
          </tr>
          <tr>
            <td class="item-updown-information">
              <div *ngFor="let data of inquiryInformation?.questionary2">
                {{ data }}.{{ getDicName(1006, data) }}
              </div>
              {{ inquiryInformation?.questionary2_other }}
            </td>
          </tr>
          <!-- （3）質問 -->
          <tr>
            <td class="item-updown-input-name">
              <div>（3）質問</div>
              <div class="input-name-note">
                ※複数選択可。<br />
                ※「その他」を選択の場合は、下の記入欄に内容を御記入ください。
              </div>
            </td>
          </tr>
          <tr>
            <td class="item-updown-information">
              <div *ngFor="let data of inquiryInformation?.questionary3">
                {{ data }}.{{ getDicName(1007, data) }}
              </div>
              {{ inquiryInformation?.questionary3_other }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- 共通部品_承認時ダイアログ -->
<app-approval-dialog
  (returnApproval)="getDetailInquiry()"
></app-approval-dialog>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
